import AiBotUnansweredAPI from 'dashboard/api/aiBot/unanswered';
import { throwErrorMessage } from '../../utils/api';

const types = {
  SET_UI_FLAG: 'SET_UI_FLAG',
  SET_RECORDS: 'SET_RECORDS',
  SET_META: 'SET_META',
};

export const state = {
  records: [],
  meta: {},
  uiFlags: {
    isFetching: false,
  },
};

export const getters = {
  getRecords: $state => $state.records,
  getUIFlags: $state => $state.uiFlags,
  getMeta: $state => $state.meta,
};

export const actions = {
  get: async ({ commit }, { botId, status, category, page } = {}) => {
    commit(types.SET_UI_FLAG, { isFetching: true });
    try {
      const response = await new AiBotUnansweredAPI(botId).get({
        status,
        category,
        page,
      });
      commit(types.SET_RECORDS, response.data.payload);
      commit(types.SET_META, response.data.meta);
      return response.data;
    } catch (error) {
      throwErrorMessage(error);
      return null;
    } finally {
      commit(types.SET_UI_FLAG, { isFetching: false });
    }
  },

  promote: async (_, { botId, id, answer, keywords }) => {
    try {
      const response = await new AiBotUnansweredAPI(botId).promote(id, {
        answer,
        keywords,
      });
      return response.data;
    } catch (error) {
      throwErrorMessage(error);
      return null;
    }
  },

  dismiss: async (_, { botId, id }) => {
    try {
      await new AiBotUnansweredAPI(botId).dismiss(id);
      return true;
    } catch (error) {
      throwErrorMessage(error);
      return null;
    }
  },
};

export const mutations = {
  [types.SET_UI_FLAG]($state, data) {
    $state.uiFlags = { ...$state.uiFlags, ...data };
  },
  [types.SET_RECORDS]($state, records) {
    $state.records = records;
  },
  [types.SET_META]($state, meta) {
    $state.meta = meta;
  },
};

export default {
  namespaced: true,
  actions,
  state,
  getters,
  mutations,
};
